import { render, staticRenderFns } from "./ProductInfoSellPrices.vue?vue&type=template&id=83b37644"
import script from "./ProductInfoSellPrices.vue?vue&type=script&lang=ts"
export * from "./ProductInfoSellPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b37644')) {
      api.createRecord('83b37644', component.options)
    } else {
      api.reload('83b37644', component.options)
    }
    module.hot.accept("./ProductInfoSellPrices.vue?vue&type=template&id=83b37644", function () {
      api.rerender('83b37644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoSellPrices.vue"
export default component.exports